import { Collapse, Flex } from "@chakra-ui/react";
import { HeaderFlagBox } from "../HeaderFlagBox";
import { HeaderLogo } from "../HeaderLogo";
import type { HeaderDesktopProps } from "../types";
import { HeaderLinks } from "./HeaderLinks";
import { ActionButton } from "../HeaderButtons/ActionButton";

export const HeaderDesktop = ({
  headerLinks,
  headerActionButton,
  headerFlagBoxHideForStories,
  pageLanguage,
  headerLogo,
  shouldHideSecondRow,
}: HeaderDesktopProps) => (
  <>
    <Flex>
      <HeaderLogo language={pageLanguage} headerLogo={headerLogo} />
      <HeaderFlagBox
        headerFlagBoxHideForStories={headerFlagBoxHideForStories}
        testId="header-flag-box-language-switcher"
      />
      <ActionButton activeButtonOption={headerActionButton} />
    </Flex>
    <Collapse in={shouldHideSecondRow} animateOpacity>
      <HeaderLinks headerLinks={headerLinks} />
    </Collapse>
  </>
);
